<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M12 5.00005V19.0001C12 19.891 10.9229 20.3371 10.2929 19.7072L6.58579 16.0001H3C2.44772 16.0001 2 15.5523 2 15.0001V9.00005C2 8.44777 2.44772 8.00005 3 8.00005H6.58579L10.2929 4.29294C10.9229 3.66298 12 4.10915 12 5.00005ZM15.1105 6.54317C15.3628 6.0519 15.9656 5.8582 16.4569 6.11052C18.6126 7.21776 20 9.48386 20 12.0001C20 14.5162 18.6126 16.7823 16.4569 17.8896C15.9656 18.1419 15.3628 17.9482 15.1105 17.4569C14.8581 16.9657 15.0518 16.3629 15.5431 16.1105C17.0328 15.3454 18 13.7656 18 12.0001C18 10.2345 17.0328 8.6547 15.5431 7.88958C15.0518 7.63725 14.8581 7.03444 15.1105 6.54317ZM10 7.41427V16.5858L7.70711 14.2929C7.55083 14.1367 7.34815 14.0375 7.13144 14.0087L7 14.0001H4V10.0001H7C7.22101 10.0001 7.43448 9.92689 7.60803 9.79397L7.70711 9.70716L10 7.41427Z"
    fill="currentColor"
  />
</svg>
